<div class="modal-main-wrapper">
    <div class="close-container">
        <div class="img-container">
            <img src="../../../assets/icons/Close.svg" (click)="close()">
        </div>        
    </div>
    <div class="content-wrapper">
        <img src="../../../assets/icons/icon-rejected.svg" alt="error icon"  class="icon"/>
        <div class="message bold">{{info.message}}</div>
        <div class="description">{{info.description}}</div>
    </div>
    <footer>
    <div class="button-wrapper">
        <button class="action-btn white-text" (click)="close()">{{"Okay"  | transloco}}</button>
    </div>
</footer>
</div>